import { useMediaQuery } from "@mui/material";

export default function useTabletSize() {
  return useMediaQuery("(max-width: 1200px) and (min-width: 980px)");
}

